<ul class="activity-items {{#if all_complete}}all-completed{{/if}}"></ul>